import React from "react";
import PropTypes from "prop-types";
import { CUSTOMISATION_OPTIONS } from "../../constants/all-customisation-options";

const propTypes = {
  layerSize: PropTypes.instanceOf(Object).isRequired,
  initialsState: PropTypes.instanceOf(Object).isRequired,
};

const InitialsLayer = ({ layerSize, initialsState }) => {
  const height = `${layerSize.height}px`;
  const width = `${layerSize.width}px`;
  const selectedOption =
    CUSTOMISATION_OPTIONS.initials.options[initialsState.selected];
  const textColor = selectedOption.selectionAsset.colors[0];
  const fontSize = `${30 * (layerSize.height / 1679)}px`;

  return (
    <div
      className="absolute initials-container"
      style={{
        "--container-height": height,
        "--container-width": width,
      }}
    >
      <div
        className="initials-text absolute opacity-95"
        style={{ "--font-size": fontSize, color: textColor }}
      >
        {initialsState.text}
      </div>
    </div>
  );
};

InitialsLayer.propTypes = propTypes;

export default InitialsLayer;
